// extracted by mini-css-extract-plugin
export default {"root":"PageConstatGravities_root__zvPdR","top":"PageConstatGravities_top__cfTlW"};